import { Customer } from "./customer";
import { Staff } from "./staff";

export interface OpportunityFile {
  name: string;
  url: string;
}

export enum OpportunityStatus {
  GetRequest = "GET_REQUEST",
  MakePlan = "MAKE_PLAN",
  MakeQuote = "MAKE_QUOTE",
  WaitApprove = "WAIT_APPROVE",
  Failed = "FAILED",
}

export enum QuoteStatus {
  WaitSend = "WAIT_SEND",
  Sent = "SENT",
  Negotiate = "NEGOTIATE",
  Revise = "REVISE",
  WaitApprove = "WAIT_APPROVE",
  CloseOrder = "CLOSE_ORDER",
  Failed = "FAILED",
}

export interface OpportunityDetail {
  id: number;
  description: string;
  unit: string;
  quantity: number;
  price: number;
  vatPercent: number;
  partnerDiscount?: number; // chỉ admin / sale phụ trách khách được trả về
}

export interface Opportunity {
  partnerName?: string; // chỉ admin / sale phụ trách khách được trả về
  canViewPartner?: boolean;
  id: number;
  createdAt: number;
  updatedAt: number;
  code: string;
  name: string;
  customerDescription: string;
  internalNote: string;
  status: OpportunityStatus;
  quoteStatus: QuoteStatus | null;
  failReason: string;
  failCategory?: string;
  failNote?: string;
  customerFiles: OpportunityFile[];
  internalFiles: OpportunityFile[];
  links: string[];
  totalAmount?: number;
  totalAmountWithVat?: number;
  orderId?: number | null;
  customer: Customer | null;
  createdStaff?: Staff | null;
  opportunityDetails?: OpportunityDetail[];
}

export interface OpportunityCounts {
  all: number;
  noQuote: number;
  statuses: Record<OpportunityStatus, number>;
  quoteStatuses: Record<QuoteStatus, number>;
}
